<div class="hidden md:flex z-[1] absolute top-0 left-0 overflow-hidden h-screen w-screen self-center"><img
        class="min-h-[100vh] min-w-[100vw]" style="object-fit: cover;" src="../../assets/login_background.png"></div>
<div class="w-screen h-screen overflow-y-scroll flex place-content-center items-center bg-tertiary absolute top-0 left-0 z-[2] cut-bg"
    *transloco="let t;prefix:'auth'">
    <div class="md:w-[350px] grid pb-[10vh] h-screen">
        <div title class="text-[48px] pt-[20px] font-bold text-center mx-[18px] text-primary italic">
            <img class="" [src]="'../assets/logo.png'" />
        </div>

        <div><std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input"
                [label]="t('email')" [placeholder]="t('email')" customContainerlass="mb-8" [(ngModel)]="email"
                [value]="email" id="email-login" type="email">
            </std-input>
            <std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input"
                [label]="t('password')" [placeholder]="t('password')" [(ngModel)]="password" id="password-login"
                [type]="showPassword ? 'text':'password'" [value]="password">
                <div iconRight class="flex place-content-center">
                    <img (mousedown)="showPassword = true" (mouseup)="showPassword=false" class="cursor-pointer"
                        src="../../assets/eye.svg">
                </div>
            </std-input>
            <div (click)="recoveryPassword()"
                class="text-[#2D2D2D] cursor-pointer w-fit text-[12px] opacity-50 mt-[10px] ml-auto">
                {{t('forgetPassword')}}</div>
        </div>
        <div class="ml-auto w-full pb-10">
            <std-button (click)="login()" id="button-login" size="sm"
                buttonClass="uppercase bg-primary hover:bg-primary focus:bg-primary">{{t('enter')}}</std-button>
            <!-- <div  class="text-[#2D2D2D] w-fit mx-auto text-[12px] opacity-50 mt-[10px]">
                {{t('or')}}</div>
            <std-button (click)="registration()" id="button-login" size="sm"
                buttonClass="uppercase bg-white hover:bg-white !text-primary shadow-xl focus:bg-white mt-2">{{t('register')}}</std-button> -->
        </div>


    </div>
</div>